/* eslint-disable */
import auth0 from "auth0-js";
import jwt_decode from "jwt-decode";
// import store from "../../store/index";
import { useStore } from "vuex";
import { watch, ref, onMounted, onUnmounted, onBeforeMount } from 'vue'
import { useRouter } from "vue-router";
import axios from "axios";

export default {
	name: "folderDocLogin",
	setup() {
		const store = useStore();
        const userid = ref("");
		const router = useRouter();
		const username = ref("");
		const password = ref("");
		const errr = ref("");
        const defaultdate = ref("");
        const defaultTime = ref("");
        const initialLoader=ref(false)		
        const errorBlock = ref(false);
        const loginLoader =ref(false)
		const authResult = ref("");
        var defaultStudy = ref("")
		let urlstring = ref("");
		const inputType = ref("password")
		let slitstring = ref([]);
		let baseurl = ref(process.env.VUE_APP_Service_URL);
		let urlAttibuteData = ref({});
		const visibleOn = ref(false);
        let usersettingsUrl=ref(`${process.env.VUE_APP_Service_URL}/account-core/usersettings`);
		onBeforeMount(async () => {
			localStorage.clear();
		})

		onMounted(async () => {
			await checkforfileorfolder();
			let pagewrapper = document.querySelector("#page-wrapper");
			pagewrapper.style.width = "100%";
			await store.dispatch("setNavbar", false);
		})
		onUnmounted(async () => {
			let pagewrapper = document.querySelector("#page-wrapper");
			pagewrapper.style.width = "";
			await store.dispatch("setNavbar", true);
		})

		async function checkforfileorfolder() {
			urlstring.value = location.href.substring(location.href.indexOf('?') + 1);

			slitstring.value = urlstring.value.split("&");
			slitstring.value.forEach((eachval) => {
				let valarray = eachval.split("=");
				urlAttibuteData.value[valarray[0]] = valarray[1]
			})
            userid.value=urlAttibuteData.value["Username"]
			username.value = urlAttibuteData.value["EmailId"]
		}
		async function Enablemenu() {
			await store.dispatch("setNavbar", true);
		}
    async function login() {
        localStorage.setItem("presentPage", "direct");
        localStorage.setItem("currentdocprocess", urlAttibuteData.value["Type"]);
        errr.value = "";
        errorBlock.value = false;
        loginLoader.value = true;
         
        try {
            const res = await axios.post(`${baseurl.value}/account-core/user/userauthorize`, {               
                userName: userid.value,
                userEmail: username.value,
                password: password.value
            }
        );
            

            loginLoader.value = false;
            authResult.value = res.data;          
            loginAudit(authResult.value);
            setdefaultstudy(authResult.value);

            await getUserSettings(authResult.value); // ensure it's finished before continuing
            setTimeout(() => {
                setuserrole(authResult.value);
            }, 2000);
               

        }
        catch(err){       
          if(err && err.response && err.response.data.errors){
            if (err.response.data.errors.UserName && err.response.data.errors.UserName.length !== 0) {
              errorBlock.value=true
              loginLoader.value=false
              errr.value = "The username field is required";
            } else if (err.response.data.errors.UserEmail && err.response.data.errors.UserEmail.length !== 0) {
              errorBlock.value=true
              errr.value = "The email field is required";
              loginLoader.value=false
            } else if (err.response.data.errors.Password && err.response.data.errors.Password.length !== 0) {
              errorBlock.value=true
              errr.value = "The password field is required";
              loginLoader.value=false
            }
          }
          else {
            if(err && err.response && err.response.data === "The username is not associated with this account.")
            {
              errorBlock.value=true
              errr.value = "The username is not associated with this account."
              loginLoader.value=false
            }
            
            else if (err && err.response &&  err.response.data === "Invalid email or password."){
              errorBlock.value=true
              errr.value = "Invalid email or password."
              loginLoader.value=false
            }
            else if(err && err.response && err.response.data== "Your account has been blocked after multiple consecutive login attempts. We've sent you an email with instructions on how to unblock it.")
            {
              alert("Your account has been blocked after multiple consecutive login attempts. We've sent you an email with instructions on how to unblock it.")
              loginLoader.value=false
            }
            else if (err && err.response && err.response.data == "Your password has been expired. Please reset your password.") {
                      alert("Your password has been expired. Please reset your password.")
                      router.push(`/ResetPassword/${username.value}/reset/Webapp`);
                      loginLoader.value=false
                    }
          }
           loginLoader.value=false
        }
           
		}
		async function passwordVisible() {
			visibleOn.value = !visibleOn.value
			if (visibleOn.value == true) {
				inputType.value = "text"
			}
			else inputType.value = "password"
        }
        async function loginAudit(authresult) {
            initialLoader.value=true
            const token = authresult.idToken;
            const emailId = await jwt_decode(token).email;
            await axios
            .post(`${baseurl.value}/account-core/user/saveloginaudit`,
                {
                "userEmail": emailId,
                "logdetails": [
                    {
                    "action": "Log In",
                    "date": "2022-08-30T09:10:42.634Z",
                    "time": "2022-08-30T09:10:42.634Z"
                    }
                ]
                }
                ,
                {
                headers: {
                    Authorization: "Bearer " + token,
                    "Content-Type": "application/json",
                },
                })
            .then((res) => {
                
            })
            .catch((err) => {
                initialLoader.value=false
                console.log(err);
            });
        }
         async function getdefaultlanguage(authresult) {
              const idtoken = authresult.idToken;
              const userId = await jwt_decode(idtoken).email;
              await axios
                .get(
                  `${baseurl.value}/account-core/usersettings/getbyid?userId=` + userId.trim(),
                  {
                    headers: {
                      Authorization: "Bearer " + idtoken,
                      "Content-Type": "application/json",
                    },
                  }
                )
                .then((res) => {
                  if (res.data.localLanguage) {
                    localStorage.setItem("lang", res.data.localLanguage);
                  }
                  if (res.data.graphType) {
                    localStorage.setItem("graphType", res.data.graphType);
                  }
        
                })
                .catch((err) => {
                  console.log(err);
                  initialLoader.value=true
                });
        }
        async function setdefaultstudy(authresult) {
            await getdefaultlanguage(authresult);
            const idtoken = authresult.idToken;
            const userId = await jwt_decode(idtoken).email;
            await axios
                .get(`${baseurl.value}/management/study/getdefaultstudy?id=` + userId, {
                headers: {
                    Authorization: "Bearer " + idtoken,
                    "Content-Type": "application/json",
                },
                })
                .then((res) => {
                if (res.statusText == "No Content") {
                } else {
                    store.dispatch("setStudyID", res.data.studyID);
                }
                })
                .catch((err) => {
                    initialLoader.value=false
                    console.log(err);
                });
        }
        async function getUserSettings(authresult) {
            
            const idtoken = authresult.idToken;
            const emailId = await jwt_decode(idtoken).email;
            await axios
            .get(
                `${usersettingsUrl.value}/getbyid?userId=${emailId}`,
                {
                headers: {
                    Authorization: "Bearer " + idtoken,
                    "Content-Type": "application/json",
                }
                },
            )
            .then((res) => {
                defaultdate.value = res.data.dateFormat; 
                defaultTime.value = res.data.timeFormat;                    
                if(defaultdate.value=="undefined" || defaultdate.value==null)
                {
                    localStorage.setItem("dateformat","DD/MM/YYYY")
                }
                else{
                localStorage.setItem("dateformat",defaultdate.value)
                }
    
                if(defaultTime.value=="undefined" || defaultTime.value==null)
                {
                    localStorage.setItem("timeformat","h:mm A")
                }
                else{
                    localStorage.setItem("timeformat", defaultTime.value);
                }
            })
            .catch((err) => {
                console.log(err);
                initialLoader.value=false
            });
        }
        async function setuserrole(authresult) {
            const idtoken = authresult.idToken;
            const userid = (jwt_decode(idtoken).sub).trim();
            await axios
            .get(baseurl.value + "/account-core/user/getuserwithauthid?id=" + userid, {
            headers: {
                Authorization: "Bearer " + idtoken,
                "Content-Type": "application/json",
            },
            })
            .then(async (res) => {
            store.dispatch("setroles", res.data[0].role);
            await getRolePrivilege(res.data[0].role, authresult);
            })
            .catch((err) => {
            console.log(err);
            initialLoader.value=false
            });
        }
        async function getRolePrivilege(array, authresult) {
            const idtoken = authresult.idToken;
            array.forEach(async (eachrole) => {
                await axios
                .get(`${baseurl.value}/account-core/roles/getscreenroleprivilegebyid?guid=${eachrole}`, {
                    headers: {
                    Authorization: "Bearer " + idtoken,
                    "Content-Type": "application/json",
                    },
                })
                .then(async (res) => {
                    if (res.data != "No ScreenRolePrivilege found") {
                    await setrolesprivileges(res.data.screens, authresult);
                    }
                })
                .catch((err) => {
                    console.log(err);
                    initialLoader.value=false
                });
            });

            }
        async function getStudy(studyId,authresult) {
            const idtoken = authresult.idToken;
            await axios.get(`${baseurl.value}/management/study/getbyid?id=${studyId}`, {
                headers: {
                Authorization: "Bearer " + idtoken,
                "Content-Type": "application/json",
                }
            }).then((res)=>{
                defaultStudy = res.data;
            })
                .catch(err => console.log("error while getting default study", err));
            
        }
        async function setrolesprivileges(data, authresult) {
            let privilegevalues = [];            
            await getStudy(localStorage.getItem("study_id_ref"),authresult);
            if(defaultStudy.isLocked !=true){
                await (data).forEach((screen) => {
                for (let j = 0; j < screen.controls.length; j++) {
                    if (!privilegevalues.includes(screen.name + " " + screen.controls[j])) {
                    privilegevalues.push(screen.name + " " + screen.controls[j]);
                    }
                }
                });
            }
            else{
                await (data).forEach((screen) => {
                for (let j = 0; j < screen.controls.length; j++) {
                    if (!privilegevalues.includes(screen.name + " " + screen.controls[j])) {
                            if(defaultStudy.lockedItems["Visits"] == true){
                            if(privileges.value.Visits.includes(screen.name + " " + screen.controls[j])){;
                            }else{
                                privilegevalues.push(screen.name + " " + screen.controls[j]);
                            }
                            }
                        }
                    }
                });
            }   
            let userprivilegestring = privilegevalues.join();
            await store.dispatch("setrolesprivileges", `test test,${userprivilegestring}`);
            store.dispatch("loginuser", authresult);
            initialLoader.value=false
              store.dispatch("setStudyID", urlAttibuteData.value["StudyId"]);
                window.dispatchEvent(
                    new CustomEvent("studyIdChanged", {
                        detail: {
                            storage: store.getters.getStudyIs,
                        },
                    })
                );
                store.dispatch("setDefaultMenu", "ETMF");
            if (urlAttibuteData.value["Type"] === "File") {          
                router.push(`/documentview/${urlAttibuteData.value["DocumentId"]}/0`);
            }
            if (urlAttibuteData.value["Type"] === "Folder") {
                store.dispatch("setFolderId", urlAttibuteData.value["FolderId"]);
                store.dispatch("setopenfolder", urlAttibuteData.value["FolderId"])
                
                router.push(`/etmf`);
                
            }
            console.log("urlAttibuteData.valu:", urlAttibuteData.value);
            //  if (urlAttibuteData.value["Type"] === "DocApprove") { 
                localStorage.setItem("passedactiontype", urlAttibuteData.value["Type"]);  
                 router.push(`/documentview/${urlAttibuteData.value["DocumentId"]}/${urlAttibuteData.value["Version"]}`);         
            // }
            // if (urlAttibuteData.value["Type"] === "DocReview") {
            //     router.push(`/documentview/${urlAttibuteData.value["DocumentId"]}/${urlAttibuteData.value["Version"]}`);
            // }
            // if (urlAttibuteData.value["Type"] === "DocQC") {
            //     router.push(`/documentview/${urlAttibuteData.value["DocumentId"]}/${urlAttibuteData.value["Version"]}`);
            // }
            
        }
		return {
			username,
			password,
			errorBlock,
            loginLoader,
			errr,
			Enablemenu,
			login,
			passwordVisible,
			visibleOn,
			inputType,
			authResult,
            initialLoader,
            getUserSettings,
            setdefaultstudy,
            loginAudit

		};

	},


}